module.exports = __webpack_public_path__ + "img/PD_6.572d0d78.png";